import { isClient } from './device-utils';

const PAGE_PREFIX = 'page';

export const getCurrentPageNumber = (url?: string) => {
  const urlToTest = url || isClient() ? window.location.href : '';
  const currentPage = isClient() ? Number(urlToTest.match(`${PAGE_PREFIX}=([^&]*)`)?.[1]) : -1;
  return isNaN(currentPage) || currentPage <= 0 ? 1 : currentPage;
};

export const hasValueInUrl = (value: string): boolean =>
  (isClient() ? window.location.href.includes(value) : false) ?? false;
